import React, {SVGAttributes} from 'react'

const Down: React.FC<SVGAttributes<SVGElement>> = (props) => (
  <svg width={17} height={10} viewBox="0 0 17 10" stroke="#000" strokeWidth={2} {...props}>
    <path d="M1 1l7.44 7L16 1" fill="none" />
  </svg>
)

export default Down
